import React from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { Link } from "@mui/material";

const NavLinkItem = ({ to, label }) => {
    const location = useLocation();
    const isActive = location.pathname === to;

    return (
        <Link
        component={RouterLink}
        to={to}
        underline="hover"
        sx={{
            color: "white",
            mr: 1,
        }}
        >
        {label}
        </Link>
    );
};

export default NavLinkItem;
